import {useCallback, useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {allLangs} from './all-langs';
import {changeLangMessages as messages} from './config-locales';
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";

// ----------------------------------------------------------------------

export function useTranslate() {
    const navigate = useNavigate()

    const {t, i18n} = useTranslation();

    const [currentLang, setCurrentLang] = useState(allLangs.find((lang) => lang.value === i18n.language));

    const onChangeLang = useCallback(
        async (newLang) => {
            try {
                // const nL = allLangs.find((lang) => lang.value === newLang);
                // if (nL) settings.onUpdateField('fontFamily', nL.fontFamily);
                const langChangePromise = i18n.changeLanguage(newLang);

                const currentMessages = messages[newLang] || messages.fa;

                await toast.promise(langChangePromise, {
                    loading: currentMessages.loading,
                    success: () => currentMessages.success,
                    error: currentMessages.error,
                });
                setCurrentLang(allLangs.find((lang) => lang.value === newLang))

                navigate(0)
            } catch (error) {
                console.error(error);
            }
        },
        [currentLang, setCurrentLang, i18n, navigate, allLangs]
    );

    return useMemo(() => ({
        t,
        i18n,
        onChangeLang,
        currentLang,
    }), [t, currentLang, i18n, onChangeLang]);
}
